import * as React from 'react';
import {
  Bar,
  BarChart,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip as ReTooltip,
  XAxis,
  YAxis,
} from 'recharts';
import NumberFormat from 'react-number-format';
import { formatAsDollars, percentage } from '../../../../lib/helpers';
import Tooltip from '../../../utility/Tooltip';
import PricePointerText from './PricePointerText';

import styles from '../../../../styles/sass/pages/Tools.module.scss';

const darkOrange = '#FFA726';
const lightBlue = '#4FC3F7';
const darkBlue = '#42a5f5';

export interface Props {
  data: any[];
}

const PricePointContent = (props: Props) => (
  <div className={styles.pricePointerContainer}>
    <PricePointerText data={props.data} />
    <div className="row middle-xs center-xs">
      <h2>Premium Paid Over Asking Price</h2>
      <Tooltip text="The amount that houses sold for relative to what they were listed at. Ex. a 5% premium on a $500,000 list price means a $525,000 sale price." />
    </div>
    <ResponsiveContainer width="100%" height={350}>
      <ComposedChart
        data={props.data}
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
      >
        <XAxis dataKey="month" />
        <YAxis tickFormatter={percentage} />
        <ReTooltip
          formatter={(value: any) => {
            return `${(value * 100).toFixed(1)}%`;
          }}
        />
        <Legend />
        <Line
          type="monotone"
          dataKey="avgPriceDelta"
          name="Avg. Price Premium"
          stroke={darkBlue}
          connectNulls
        />
        <Line
          type="monotone"
          dataKey="deltaTrend"
          name="Price Premium Trend"
          stroke={lightBlue}
          strokeDasharray="5 5"
          connectNulls
          dot={false}
          activeDot={false}
          legendType="none"
        />
      </ComposedChart>
    </ResponsiveContainer>
    <br />
    <div className="row middle-xs center-xs">
      <h2>Asking vs. Sale Price</h2>
      <Tooltip text="Shows the median price values used to calculate the above trend." />
    </div>
    <ResponsiveContainer width="100%" height={350}>
      <BarChart
        data={props.data}
        barGap={0}
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
      >
        <XAxis dataKey="month" />
        <YAxis stroke={darkBlue} tickFormatter={formatAsDollars} />
        <ReTooltip
          formatter={(val: any) => (
            <NumberFormat
              value={val}
              displayType="text"
              thousandSeparator
              prefix="$"
              decimalScale={0}
            />
          )}
        />
        <Legend />
        <Bar
          dataKey="medianListPrice"
          name="Median Asking Price"
          barSize={15}
          fill={darkBlue}
        />
        <Bar
          dataKey="medianSalePrice"
          name="Median Sale Price"
          barSize={15}
          fill={darkOrange}
        />
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export default PricePointContent;
